module.exports = __webpack_public_path__ + "static/img/fire.abf2621.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animated/fire.gif
// module id = UDBY
// module chunks = 0